"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
var Status;
(function (Status) {
    Status["OPEN"] = "open";
    Status["ERROR"] = "error_in_processing";
    Status["CLOSED"] = "closed";
    Status["RECEIVED"] = "received";
    Status["CONFIRMATION_SENT"] = "confirmation_sent";
    Status["CONTACT_PERSON_APPOINTED"] = "contact_person_appointed";
    Status["WORKING_ON_SOLUTION"] = "working_on_solution";
    Status["PROPOSAL_READY"] = "proposal_ready_for_discussion";
    Status["SECOND_OPINION_REQUESTED"] = "2nd_opinion_requested";
    Status["NEW_PROPOSAL"] = "new_proposal";
})(Status = exports.Status || (exports.Status = {}));
